.error {
	color: var(--color-error-text);

	&:empty {
		display: none;
	}
}
